<template>
  <v-card outlined height="100%">
    <v-card-text class="pa-3">
      <div class="d-flex align-center text-caption text--secondary">
        <v-icon small class="mr-1">{{ icon }}</v-icon>
        {{ label }}
        <v-tooltip v-if="hint" top max-width="320">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              x-small
              color="grey"
              class="ml-1"
              v-bind="attrs"
              v-on="on"
            >
              mdi-information-outline
            </v-icon>
          </template>
          <span>{{ hint }}</span>
        </v-tooltip>
      </div>
      <div class="text-h6 font-weight-bold mt-1">{{ value }}</div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'RlrRatingMetricCard',
  props: {
    label: String,
    value: [String, Number],
    icon: String,
    hint: String
  }
}
</script>
